import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2yc6uznjzg: FaireBrandEntity = {
  token: "b_2yc6uznjzg",
  type: "brand",
  name: "Kindred Objects",
  avatarUrl:
    "https://cdn.faire.com/fastly/6854ef2307e514f2d4c0f67d29f975ef91744f3db6b0d01bdc1865cadb58515a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ba1101b8000eb5651d8436476f1d6984a65758cecf63d33a426e07c1480b5fc3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6854ef2307e514f2d4c0f67d29f975ef91744f3db6b0d01bdc1865cadb58515a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ba1101b8000eb5651d8436476f1d6984a65758cecf63d33a426e07c1480b5fc3.jpeg",
  location: "Portland, OR, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 18,
  isTopShop: true,
  isInsider: true,
  description:
    "Kindred Objects is a sustainable brand that reimagines vintage jewelry for the modern era. We source rare, deadstock supplies from vintage warehouses and ethical manufacturers to create unique, small-batch jewelry. Our mission is to reduce waste without compromising style, giving forgotten treasures a new life. Every piece is thoughtfully packaged with eco-friendly materials, ensuring that sustainability is at the heart of everything we do.\n\nReach out to us by message for any custom inquiries - additional necklace lengths, adding necklace extenders, etc. We'll try to help however we can!",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:36.337Z",
    importedBy: "entity-db-cli",
  },
};
